import { Injectable } from "@angular/core";
import { identifierModuleUrl } from "@angular/compiler";

@Injectable()
export class Globals {
  public role: any;
  public one: any;
  public last: any;
  public between: any;
  public adCost: any;
  public adSize: any;
  public adRate: any;
  public color_flag: boolean;
  public radio_flag: boolean;
  public adcustom_size: any;
  public fileSize: any;
  public adDays: number;
  public adDateStored: number = 1;
  public adDates: Array<any>;
  public adDates_temp: Array<any>;
  public adDateCounter: number = 0;
  public array1: any[][];
  public adDates1_temp: any[] = [
    {
      id: "",
      advtDate: ""
    }
  ];

  //static adCost: DoubleRange;
}
